
import { useEffect } from 'react';

interface PageTitleProps {
  title: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogUrl?: string;
  ogImage?: string;
}

export const PageTitle: React.FC<PageTitleProps> = ({ title, description, ogTitle, ogDescription, ogUrl, ogImage }) => {
  useEffect(() => {
    // Update the document title
    const previousTitle = document.title;
    document.title = title;

    // Handle meta description
    if (description) {
      let descTag = document.querySelector('meta[name="description"]') as HTMLMetaElement;
      if (!descTag) {
        descTag = document.createElement('meta');
        descTag.setAttribute('name', 'description');
        document.head.appendChild(descTag);
      }
      descTag.setAttribute('content', description);
    }

    // Handle Open Graph meta tags
    const metaTags: HTMLMetaElement[] = [];

    if (ogTitle) {
      let ogTitleTag = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
      if (!ogTitleTag) {
        ogTitleTag = document.createElement('meta');
        ogTitleTag.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitleTag);
      }
      ogTitleTag.setAttribute('content', ogTitle);
      metaTags.push(ogTitleTag);
    }
    
    if (ogDescription) {
      let ogDescTag = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
      if (!ogDescTag) {
        ogDescTag = document.createElement('meta');
        ogDescTag.setAttribute('property', 'og:description');
        document.head.appendChild(ogDescTag);
      }
      ogDescTag.setAttribute('content', ogDescription);
      metaTags.push(ogDescTag);
    }
    
    if (ogUrl) {
      let ogUrlTag = document.querySelector('meta[property="og:url"]') as HTMLMetaElement;
      if (!ogUrlTag) {
        ogUrlTag = document.createElement('meta');
        ogUrlTag.setAttribute('property', 'og:url');
        document.head.appendChild(ogUrlTag);
      }
      ogUrlTag.setAttribute('content', ogUrl);
      metaTags.push(ogUrlTag);
    }

    if (ogImage) {
      let ogImageTag = document.querySelector('meta[property="og:image"]') as HTMLMetaElement;
      if (!ogImageTag) {
        ogImageTag = document.createElement('meta');
        ogImageTag.setAttribute('property', 'og:image');
        document.head.appendChild(ogImageTag);
      }
      ogImageTag.setAttribute('content', ogImage);
      metaTags.push(ogImageTag);
    }

    // Cleanup function to restore the previous title when component unmounts
    return () => {
      document.title = previousTitle;
      // Note: We don't remove the meta tags as they should persist for the page
    };
  }, [title, description, ogTitle, ogDescription, ogUrl, ogImage]);
  
  // This component doesn't render anything
  return null;
};
